export default __webpack_public_path__ + "static/media/filter.e0d6b0ab.svg";